import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardHeader,
    Dialog,
    Divider,
    Grid,
    makeStyles,
    Typography,
    useMediaQuery,
    useTheme,
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import './loaderstyle.css';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    card: {
        textAlign: 'center',
        width: '100%',
    },
    bottomLine: {
        width: '100%',
        height: 0,
    },
}));
const SuccessPopUp = (props) => {
    const { showSuccess, handleClose, title, disableBackdropClick } = props;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useStyles();

    return (
        <div>
            <Dialog
                fullScreen={fullScreen}
                open={showSuccess}
                onClose={handleClose}
                disableBackdropClick={disableBackdropClick !== null ? disableBackdropClick : true}
                className="loader-dialog loaderSuccess"
            >
                <Card className="card-size">
                    <CardContent className={classes.card}>
                        <Typography className="loader-title"> SUCCESS</Typography>
                        <CheckCircleIcon className="successpopup" style={{ fontSize: 50 }} />
                        <Typography className="loader-content successpopup"> {title}</Typography>
                        {/* <Button variant="outlined" className="spinnerbtnText" disabled> */}
                        {/* </Button> */}
                    </CardContent>
                </Card>
            </Dialog>
        </div>
    );
};

export default SuccessPopUp;
